var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-wrapper"},[_c('crud',{ref:"crud",attrs:{"form-component":_vm.PendingAppUsersForm,"grid-columns":_vm.gridColumns,"grid-options":_vm.gridOptions,"gridSettings":{noNew: true},"obj":"pendingAppUser"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9e501aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PendingAppUsers.vue
// module id = null
// module chunks = 